
import { Button } from "@mui/material";
//import { toast } from "react-toastify";
import "./index.scss";
import { useEffect, useState } from "react";
import { HTTP_METHODS, invokeApi, invokeFileApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import { saveAs } from "file-saver"
import CustomTable from "../../../../core/custom-table";

const TrainingReport = () => {
   const [reportsData, setReportsData] = useState([]);
    const [reportsTableHeaderConfig, setReportsTableHeaderConfig] = useState([]);

    useEffect(()=>{
        invokeApi(
            HTTP_METHODS.GET,
            `${HOSTNAME}${REST_URLS.DOWNLOAD_TRAINING_REPORT}`,
        ).then((response) => {  
          let headerConfig = response.headers.map((headerData)=>{
                return {
                    label: headerData,
                    value: headerData,
                    render: (data) => {
                        return( 
                            <span>{data[headerData]}</span>
                        )
                }
        }});
           setReportsTableHeaderConfig(headerConfig)
            setReportsData(response.allDataRows);
        }).catch((e) => {
            toast.error('Unable to Fetch Reports now')
        });
    },[]);

  

    const downloadReport = () => {
        invokeFileApi(
            HTTP_METHODS.GET,
            `${HOSTNAME}${REST_URLS.DOWNLOAD_TRAINING_REPORT}?download=TRUE`,
        ).then((response) => {     
            saveAs(response, 'planned-vs-actual-report.xlsx')
        }).catch((e) => {
            toast.error('Download Reports Failed')
        });
    };



    return (
        <>
            <div className="training-plan-vs-actual-container">
                <div className="title-container">
                    <span className="training-title">Training</span>
                    <div className="list-title">View Plan vs Actual Hours</div>
                </div>
                <div className='reports-header-container'>
                    <div className="header">Planned Hours VS. Actual Hours</div>
                    <Button
                        variant='contained'
                        sx={{ borderRadius: '5', color: '#ffffff', backgroundColor: 'green', '&:hover': { backgroundColor: 'green' } }}
                        onClick={() => downloadReport()}
                    >
                        Download Report in XLSX
                    </Button>
                </div>             
                <div className="list-container">
                <CustomTable
                    header={reportsTableHeaderConfig}
                    data={reportsData || []}
                    //pageCount={pastTickets.totalPages}
                    //onClick={onRowClick}
                    //filters={filters}
                    /* onChange={(page) => {
                        setFilters({
                        ...filters,
                        page,
                        }); */
                        /* loadData({
                        ...filters,
                        page,
                        }); */
                    //}}
                    />
                </div>
            </div>
        </>
    )
};

export default TrainingReport;